import { mapSearchResultsToProductData } from '../helpers/map-search-results-to-product-data';
import { getPBasketSearchResultsStringProvider } from '../product-basket';

export const SEARCH_PROVIDER_PROPERTIES = {
  searchUrl: '',
  maxNrOfProductsToShow: 10,
  imgToUse: 'article',
  searchResults: getPBasketSearchResultsStringProvider({
    url: {
      provider: 'self',
      property: 'searchUrl',
    },
    nrOfProducts: {
      provider: 'self',
      property: 'maxNrOfProductsToShow',
    },
  }),
  productData: {
    values: [
      {
        provider: 'self',
        property: 'searchUrl',
      },
      {
        provider: 'self',
        property: 'searchResults',
      },
      {
        provider: 'self',
        property: 'maxNrOfProductsToShow',
      },
      {
        provider: 'self',
        property: 'imgToUse',
      },
    ],
    transform: mapSearchResultsToProductData.toString(),
  },
};
